require('./modal.js');

Pegasus.HelpVideoModal = Pegasus.Modal.extend({
  title: Pegasus.computed.t('g.help_video'),
  width: '700px',
  classNames: ['editor-help-video'],
  bodyTemplateName: 'modals/help_video',
  headerClassName: 'editor-modal-header',
  hasFooter: false,
  didCancel: function(){
    this.set('controller.presenter', null);
  }
});
